module.exports = __webpack_public_path__ + "img/btn-reservation-no.84a4c2b1.png";